import { invariant } from '@tanstack/react-router';

import { cloudEnterprisePolicyApiClient } from '../clients/cloudEnterprisePolicyApiClient';
import type {
  Policies,
  PolicyAutoLockMinutesValues,
  PolicyMinimumPincodeLengthValues,
} from './cloudEnterprisePolicyApi.types';

export const getPolicyProfiles = () =>
  cloudEnterprisePolicyApiClient
    .GET('/policy/v1/profiles')
    .then((r) => r.data ?? null);

export const getPolicyProfile = (vars: { id: string }) =>
  cloudEnterprisePolicyApiClient
    .GET('/policy/v1/profiles/{id}', {
      params: {
        path: {
          id: vars.id,
        },
      },
    })
    .then((r) => r.data ?? null);

export const createPolicyProfile = (vars: {
  name: string;
  description: string;
  isDefault: boolean;
  policies: Policies;
}) =>
  cloudEnterprisePolicyApiClient
    .POST('/policy/v1/profiles', {
      body: {
        name: vars.name,
        description: vars.description,
        isDefault: vars.isDefault,
        policies: vars.policies,
      },
    })
    .then((r) => r.data ?? null);

export const updatePolicyProfile = (vars: {
  id: string;
  name: string;
  description: string;
  isDefault: boolean;
  policies: Policies;
}) =>
  cloudEnterprisePolicyApiClient
    .PUT('/policy/v1/profiles/{id}', {
      params: {
        path: {
          id: vars.id,
        },
      },
      body: {
        name: vars.name,
        description: vars.description,
        isDefault: vars.isDefault,
        policies: vars.policies,
      },
    })
    .then((r) => r.data ?? null);

/** Not yet available. */
// export const deletePolicyProfile = (vars: { id: string }) =>
//   cloudEnterprisePolicyApiClient
//     .DELETE('/policy/v1/profiles/{id}', {
//       params: {
//         path: {
//           id: vars.id,
//         },
//       },
//     })
//     .then((r) => r.data ?? null);

export const sendCommandRemoteWipe = (vars: {
  userId: string;
  deviceId?: string;
}) => {
  invariant(vars.deviceId, 'deviceId is missing');

  return cloudEnterprisePolicyApiClient
    .POST('/policy/v1/commands', {
      body: {
        command: {
          command: 'remoteWipe',
        },
        userId: vars.userId,
        deviceId: vars.deviceId,
      },
    })
    .then((r) => r.data ?? null);
};

export const sendCommandSetPasscodeLength = (vars: {
  userId: string;
  deviceId?: string;
  length: number;
}) => {
  invariant(vars.deviceId, 'deviceId is missing');

  return cloudEnterprisePolicyApiClient
    .POST('/policy/v1/commands', {
      body: {
        command: {
          command: 'minimumPincodeLength',
          data: {
            value: vars.length as PolicyMinimumPincodeLengthValues,
          },
        },
        userId: vars.userId,
        deviceId: vars.deviceId,
      },
    })
    .then((r) => r.data ?? null);
};

export const sendCommandSetAutolockTimeout = (vars: {
  userId: string;
  deviceId?: string;
  timeout: number;
}) => {
  invariant(vars.deviceId, 'deviceId is missing');

  return cloudEnterprisePolicyApiClient
    .POST('/policy/v1/commands', {
      body: {
        command: {
          command: 'maximumLightSleepDelay',
          data: {
            value: vars.timeout as PolicyAutoLockMinutesValues,
          },
        },
        userId: vars.userId,
        deviceId: vars.deviceId,
      },
    })
    .then((r) => r.data ?? null);
};

export const sendCommandSoftwareAutoInstall = (vars: {
  userId: string;
  deviceId?: string;
  enable: boolean;
}) => {
  invariant(vars.deviceId, 'deviceId is missing');

  return cloudEnterprisePolicyApiClient
    .POST('/policy/v1/commands', {
      body: {
        command: {
          command: 'softwareAutoInstall',
          data: {
            value: vars.enable,
          },
        },
        userId: vars.userId,
        deviceId: vars.deviceId,
      },
    })
    .then((r) => r.data ?? null);
};

export const sendCommandSoftwareForceRestart = (vars: {
  userId: string;
  deviceId?: string;
  enable: boolean;
}) => {
  invariant(vars.deviceId, 'deviceId is missing');

  return cloudEnterprisePolicyApiClient
    .POST('/policy/v1/commands', {
      body: {
        command: {
          command: 'softwareForceRestart',
          data: {
            value: vars.enable,
          },
        },
        userId: vars.userId,
        deviceId: vars.deviceId,
      },
    })
    .then((r) => r.data ?? null);
};
